<template>
  <div class="product warp">
    <div class="main">
      <div class="table">
        <el-table v-loading="loading" :data="[tableData]" border height="44" style="min-width:1500px ;">
          <el-table-column align="center" width="500" label="订单详情"> </el-table-column>
          <el-table-column align="center" width="180" label="用户"></el-table-column>
          <el-table-column align="center" width="150" label="订单金额"></el-table-column>
          <el-table-column align="center" width="150" label="实付金额"></el-table-column>
          <el-table-column align="center" width="150" label="支付通道"></el-table-column>
          <el-table-column align="center" width="150" label="支付时间"></el-table-column>
          <el-table-column align="center" label="操作"></el-table-column>
        </el-table>

        <div v-for="item in tableData" :key="item.order_child_sn" style="min-width:1500px ;" class="shop_table">
          <el-table :data="[item]" border>
            <el-table-column width="500">
              <template slot="header">
                <span style="margin-right:50px"> {{ item.createTime }} </span> <span>订单号:{{ item.order_child_sn }}</span>
              </template>
              <template slot-scope="scope">
                <div v-for="itm in scope.row.goodsInfo" :key="itm.id">
                  <span style="width:300px">{{ itm.title }}</span> <span> X {{ itm.sku_num }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="180">
              <template slot-scope="scope">
                <div>{{ scope.row.userName }}</div>
                <div>{{ scope.row.mobilePhoe }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <span>￥{{ scope.row.priceOrder }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <span>￥{{ scope.row.payPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.payMethod == 1 ? "通联支付支付宝" : scope.row.payMethod == 2 ? "通联支付微信" : "联合" }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.payTime }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">
                  <!-- <el-link type="primary" style="margin-right: 20px" @click="DeleteOrder(scope.row)">关闭</el-link> -->
                </span>
                <span v-if="scope.row.status == 2">
                  <el-link type="primary" style="margin-right: 20px" @click="Deliver(scope.row)">发货</el-link>
                  <!-- <el-link type="primary" style="margin-right: 20px" @click="Deliver(scope.row)">退款申请审核</el-link> -->
                </span>
                <span v-if="scope.row.status == 3">
                  <!-- <el-link type="primary" style="margin-right: 20px" @click="logisticsDetail(scope.row)">物流详情</el-link> -->
                </span>
                <span>
                  <el-link type="primary" @click="hides(scope.row.id)">详情</el-link>
                </span>
                <!-- <el-link type="primary" @click="hides(scope.row.id)">详情</el-link> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            @size-change="sizeChange"
            @current-change="handleSizeChange"
            background
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- <el-dialog width="30%" title="发货" :visible.sync="dialogFormVisible">
            <div class="formD">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="收货人：" v-if="deli.orders_deliveries">
                        {{ deli.orders_deliveries.receivers_names }}
                    </el-form-item>
                    <el-form-item label="联系电话：" v-if="deli.orders_deliveries">
                        {{
                            deli.orders_deliveries.receivers_mobiles == "" || deli.orders_deliveries.receivers_mobiles == null
                                ? deli.orders_deliveries.receivers_phones
                                : deli.orders_deliveries.receivers_mobiles
                        }}
                    </el-form-item>
                    <el-form-item label="收货地址：" v-if="deli.orders_deliveries">
                        {{
                            deli.orders_deliveries.receivers_provinces + deli.orders_deliveries.receivers_citys + deli.orders_deliveries.receivers_districts + deli.orders_deliveries.receivers_address
                        }}
                    </el-form-item>
                    <el-form-item label="快递公司：" prop="express">
                        <el-select v-model="ruleForm.express" filterable placeholder="请输入或选择快递公司">
                            <el-option v-for="item in options" :key="item.id" :label="item.text" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="快递单号：" prop="ordersNumber">
                        <el-input v-model="ruleForm.ordersNumber"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="deloading">确 定</el-button>
            </div>
        </el-dialog> -->
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import help from "@/assets/js/common.js";
export default {
  name: "product",
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      loading: false,
      total: 0,
      limit: 10,
      page: 1,
      formsdatas: 0,
      ordersNumber: "",
      options: [],
      ruleForm: {
        ordersNumber: "",
        express: undefined
      },
      deloading: false,
      deli: {},
      rules: {
        ordersNumber: [{ required: true, message: "请输入快递单号", trigger: "blur" }],
        express: [{ required: true, message: "请输选择快递公司", trigger: "blur" }]
      },
      spanArr: [],
      pos: "",
      shopIDList: "" //店铺ID
    };
  },
  props: {
    isAll: {
      type: Boolean
    },
    phone: {
      type: String
    },
    ordernumber: {
      type: String
    },
    status: {
      type: String
    }
  },
  filters: {
    strFmt(val) {
      if (val && val.length > 6) {
        return val.substring(0, 6) + "...";
      }
      return val;
    }
  },
  mounted() {
    let shopIDList = JSON.parse(localStorage.getItem("shop")).shop;
    let arr = [];
    shopIDList.forEach(item => {
      arr.push(item.shop_id);
    });
    this.shopIDList = arr.join();
    this.Bind(1);
    this.getExpress();
  },
  created() {},
  methods: {
    ...mapActions({
      getOrderList: "commodity/getOrderList",
      getExpressList: "commodity/getExpressList",
      deliverGoods: "commodity/deliverGoods",
      getBeiOrderList: "commodity/getBeiOrderList" //修改成为北京查询列表接口
    }),
    DeleteOrder(item) {
      this.$emit("opendetails", item);
    },
    logisticsDetail(item) {
      this.$emit("logisticsDetailShow", item);
    },
    Deliver(item) {
      // this.deli = item;
      this.$emit("shipShow", item);
    },
    getExpress() {
      this.getExpressList({ token: this.$store.state.token }).then(res => {
        if (res.code == 1) {
          this.options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // // 发货
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //         if (valid) {
    //             this.deloading = true;
    //             this.deliverGoods({
    //                 token: this.$store.state.token,
    //                 id: parseInt(this.deli.id), //订单id
    //                 express_id: parseInt(this.ruleForm.express), //快递id
    //                 express_no: this.ruleForm.ordersNumber, //快递编号
    //             }).then((res) => {
    //                 this.deloading = false;
    //                 if (res.code == 1) {
    //                     this.$message.success("发货成功！");
    //                     this.Bind(1);
    //                     this.dialogFormVisible = false;
    //                 } else {
    //                     this.$message.error(res.msg);
    //                 }
    //             });
    //         } else {
    //             return false;
    //         }
    //     });
    // },
    hides(id) {
      // this.$emit("hide", id);
      this.$router.push({
        path: `/home/orderdetails`,
        query: {
          orderID: id
        }
      });
    },
    sizeChange(val) {
      this.limit = val;
      this.Bind(1);
    },
    getRQ(val) {
      return help.getRQ(val);
    },
    // 根据状态标识获取状态字符串
    getFieldStr(index, arr) {
      return arr[index];
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 6 || columnIndex === 7 || columnIndex === 10 || columnIndex === 11 || columnIndex === 12) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    getSpanArr(data) {
      this.spanArr = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].orders_sn === data[i - 1].orders_sn) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    Bind(offset) {
      if (offset == 1) this.page = 1;
      this.loading = true;
      let data = {
        // token: this.$store.state.token, //用户登录token
        // order_by: "id desc", //排序 字段名+空格+排序：“id asc”；asc-正序：可不拼接；desc-倒序
        // page_size: this.limit, //每页记录数
        // page: offset, //页数
        // buyers_mobile: this.phone, //买家电话
        // orders_sn: this.ordernumber, //订单编号
        // orders_status: this.status == 0 ? null : this.status,
        shopIds: this.shopIDList ? this.shopIDList : -1,
        status: this.status == 0 ? null : this.status,
        orderSn: this.ordernumber,
        // beginTime:"",
        // endTime:"",
        PageIndex: offset,
        PageSize: this.limit
      };
      // if (this.isAll) {
      //   data.orders_status = 2;
      // }
      this.getBeiOrderList(data).then(async res => {
        if (res.code == 0) {
          this.tableData.splice(0, this.tableData.length);
          this.tableData = [];
          if (res.data && res.data.length > 0) {
            res.data.forEach(item => {
              if (item.orders_goods && item.orders_goods.length > 0) {
                item.orders_goods.forEach(val => {
                  let goods = JSON.parse(JSON.stringify(item));
                  goods.goods_item = val;
                  this.tableData.push(goods);
                });
              } else {
                this.tableData.push(item);
              }
              let name = "";
              name = item.userName.substring(0, 1);
              for (let index = 0; index < item.userName.length; index++) {
                name = name + "*";
              }
              item.userName = name;
              let reg = /^(.{3}).*(.{4})$/;
              item.mobilePhoe = item.mobilePhoe.replace(reg, "$1****$2");
            });
            this.$forceUpdate();
            this.tableData.forEach(item => {
              // item.address =
              //   item.orders_deliveries.receivers_provinces +
              //   item.orders_deliveries.receivers_citys +
              //   item.orders_deliveries.receivers_districts +
              //   item.orders_deliveries.receivers_address;
              // item.receivers_names = item.orders_deliveries.receivers_names;
              // item.receivers_phones = item.orders_deliveries.receivers_phones;
              // item.company_name = item.users_merchant.company_name;
              // item.goods_names = item.goods_item.goods_names;
              // item.goods_number = item.goods_item.goods_number;
              // item.goods_payments_amounts = item.goods_item.goods_payments_amounts;
              // //  1-未支付 2-付款中 3-已支付
              // item.trades_status_str = this.getFieldStr(item.trades_status - 1, ["未支付", "付款中", "已支付"]);
              // //    1-已下单/代付款 2-已支付/代发货 3-已发货/待收货 4-已完成 5-已取消
              // item.orders_status_str = this.getFieldStr(item.orders_status - 1, ["待付款", "待发货", "待收货", "已完成", "已取消"]);
            });
          }
          // this.getSpanArr(this.tableData);
          this.total = parseInt(res.total);
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //  this.Bind((val-1)*this.limit)
      this.Bind(val);
    },
    ExportWord() {
      if (this.tableData.length == 0) {
        return this.$message.error("空数组！");
      }
      this.tableData.forEach(item => {
        let arr = [];
        item.goodsInfo.forEach(itm => {
          if (itm.title) {
            arr.push(itm.title);
          }
        });
        item.title = arr.join("");
      });
      this.getExcel(this.tableData);
    },
    getExcel(arr) {
      require.ensure([], () => {
        // 这里 require 的地址指向你项目中 Export2Excel.js 文件存放地址
        const { export_json_to_excel } = require("../../../../excel/Export2Excel.js");
        const tHeader = ["订单详情", "用户", "订单金额", "实付金额", "支付通道", "支付时间"];
        const filterVal = ["title", "userName", "payPrice", "priceOrder", "payMethod", "payTime"];
        const data = this.formatJson(filterVal, arr);
        export_json_to_excel(tHeader, data, "订单管理数据");
        this.disbtn = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    Refush() {
      this.ordersNumber = "";
      this.Bind(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.shop_table {
  ::v-deep th {
    border: none;
  }
}
::v-deep .el-table__header .has-gutter {
  .el-table__cell .gutter {
    width: 0;
  }
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0;
}
.product {
  .main {
    .table {
      overflow: hidden;
      overflow-x: auto;
      margin-top: 20px;
      .page {
        margin-top: 20px;
        float: right;
      }
    }
  }
}
::v-deep .el-table .el-table__fixed-right {
  width: 199px !important;
}
.link span {
  margin: 0 8px;
}
</style>
